import React from 'react'

import { toPx } from 'common/builder/components/chart/utils/toPx'

export const WithSpacer: React.CSSProperties = {
  marginBottom: toPx(3),
}
